import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

import { useToolCardById } from './stickerCardMapping';
import { ActionStickerCardSection, HomePageSection } from './useGetHomePageSections';

const GREAT_COLLEGE_STRINGS = appStrings.modules.home.sections.getBackedYourWay.greatCollege;
const SCORE_JOB_INTERNSHIP_STRINGS =
  appStrings.modules.home.sections.getBackedYourWay.scoreJobInternship;

export const GREAT_COLLEGE_SECTION = ({ navigate }: HomePageSection): ActionStickerCardSection => {
  const { getStickerCard } = useToolCardById({ navigate });

  return {
    title: GREAT_COLLEGE_STRINGS.title,
    description: GREAT_COLLEGE_STRINGS.description,
    actionStickerCards: [
      getStickerCard('college_shortlist'),
      getStickerCard('what_are_your_chances'),
      getStickerCard('essay_ideas'),
      getStickerCard('improve_test_scores'),
    ],
  };
};

export const SCORE_JOB_INTERNSHIP_SECTION = ({
  navigate,
}: HomePageSection): ActionStickerCardSection => {
  const { getStickerCard } = useToolCardById({ navigate });

  return {
    title: SCORE_JOB_INTERNSHIP_STRINGS.title,
    description: SCORE_JOB_INTERNSHIP_STRINGS.description,
    actionStickerCards: [
      getStickerCard('update_social_media'),
      getStickerCard('jobs_you_might_love'),
      getStickerCard('interviewing'),
      getStickerCard('boost_odds_of_an_offer'),
    ],
  };
};
